/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectServices } from './projectServices';
import { ProjectCors } from './projectCors';


export interface Project { 
    cors_admin?: ProjectCors;
    cors_public?: ProjectCors;
    /**
     * The environment of the project. prod Production stage Staging dev Development
     */
    environment: Project.EnvironmentEnum;
    /**
     * The project home region.  This is used to set where the project data is stored and where the project\'s endpoints are located. eu-central EUCentral asia-northeast AsiaNorthEast us-east USEast us-west USWest us US global Global
     */
    home_region: Project.HomeRegionEnum;
    /**
     * The project\'s ID.
     */
    readonly id: string;
    /**
     * The name of the project.
     */
    name: string;
    /**
     * The configuration revision ID.
     */
    readonly revision_id: string;
    services: ProjectServices;
    /**
     * The project\'s slug
     */
    readonly slug: string;
    /**
     * The state of the project. running Running halted Halted deleted Deleted
     */
    readonly state: Project.StateEnum;
    workspace_id?: string | null;
}
export namespace Project {
    export type EnvironmentEnum = 'prod' | 'stage' | 'dev';
    export const EnvironmentEnum = {
        Prod: 'prod' as EnvironmentEnum,
        Stage: 'stage' as EnvironmentEnum,
        Dev: 'dev' as EnvironmentEnum
    };
    export type HomeRegionEnum = 'eu-central' | 'asia-northeast' | 'us-east' | 'us-west' | 'us' | 'global';
    export const HomeRegionEnum = {
        EuCentral: 'eu-central' as HomeRegionEnum,
        AsiaNortheast: 'asia-northeast' as HomeRegionEnum,
        UsEast: 'us-east' as HomeRegionEnum,
        UsWest: 'us-west' as HomeRegionEnum,
        Us: 'us' as HomeRegionEnum,
        Global: 'global' as HomeRegionEnum
    };
    export type StateEnum = 'running' | 'halted' | 'deleted';
    export const StateEnum = {
        Running: 'running' as StateEnum,
        Halted: 'halted' as StateEnum,
        Deleted: 'deleted' as StateEnum
    };
}


